











































import outside from 'vue-outside';
import AppsIcon from 'gso-design-icons/vue/material-design/apps.vue';
import ArrowDropDownIcon from 'gso-design-icons/vue/material-design/arrow_drop_down.vue';
import AppLink from './portal-app-link.vue';

export default {
	name: 'apps',
	components: {
		AppsIcon,
		AppLink,
		ArrowDropDownIcon
	},
	directives: {
		outside
	},
	props: ['groups'],
	computed: {
		isOpen() {
			return this.$store.state.header.isOpen === 'apps';
		}
	},
	methods: {
		toggle() {
			if (this.isOpen) {
				this.$store.commit('header/close');
			} else {
				this.$store.commit('header/open', {menu: 'apps'});
			}
		},
		outside(event, el) {
			// Try to use event.target.correspondingUseElement to fix a bug in Edge 14
			// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7998724/
			const target = event.target.correspondingUseElement || event.target;
			if (el.parentElement && !el.parentElement.contains(target)) {
				if (this.isOpen) {
					this.$store.commit('header/close');
				}
			}
		}
	}
};
